var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"li",on:{"mouseup":function($event){return _vm.$router.push(_vm.path)}}},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.text)))]),_c('i',{staticClass:"fhr fhr-chevron-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }